export const ID = 'id';
export const DESCRIPTION = 'description';
export const NAME = 'name';
export const COMPANY_ID = 'companyId';
export const WORKPLACE_IMAGE_URL = 'workplaceImageUrl';